import { useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { updateTagCache } from '../utilities/cache';
import { UPDATE_TAG } from '../utilities/mutations';

const EditTagModal = ({ tagId, tagName, onClose }) => {
  const toast = useToast();
  const [updateTag] = useMutation(UPDATE_TAG);

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()}>
      <ModalExit />
      <ModalName>Edit tag</ModalName>
      <Formik
        initialValues={{ name: tagName }}
        onSubmit={async (values) => {
          try {
            await updateTag({
              variables: {
                name: values.name,
                id: tagId,
              },
              update: (cache) => updateTagCache(cache, tagId),
            });
            toast({ children: 'Tag updated' });
          } catch (error) {
            toast({ children: error.message });

            return;
          }

          close();
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <ModalPart>
              <Field>
                <FieldLabel>Tag name</FieldLabel>
                <FieldInput
                  type="name"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  data-autofocus
                />
              </Field>
            </ModalPart>
            <ModalPart>
              <Button
                type="submit"
                disabled={values.name === tagName || isSubmitting}
                isPrimary
                isExtended
              >
                Save
              </Button>
            </ModalPart>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditTagModal;
